import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Option } from '../select/options';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: [
    './multiselect.component.scss',
    '../input/input.component.scss',
    './../input/input-wrapper/input-wrapper.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class MultiselectComponent implements OnInit, OnChanges, OnDestroy {
  public innerControl = new UntypedFormControl();
  public subscriptions: Subscription = new Subscription();
  public dropdownSettings = {
    singleSelection: false,
    enableCheckAll: false,
    text: 'Select',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
  };

  @Input() public fc: UntypedFormControl;
  @Input() public label: string;
  @Input() public options: Option[];
  @Input() public emptyOption = true;

  @ViewChild('multiSelect') multiSelect: AngularMultiSelect;

  private selectedOptionsCache: Pick<Option, `id`>[] = [];

  ngOnInit(): void {
    this.subscriptions.add(
      this.fc.valueChanges.subscribe((val) => {
        this.parseSelectedOptions(val);
      })
    );

    this.subscriptions.add(
      this.innerControl.valueChanges.subscribe((selectedItems) => {
        this.selectedOptionsCache = selectedItems.map(
          (item: Option) => item.id
        );

        this.fc.setValue(this.selectedOptionsCache, { emitEvent: false });
      })
    );

    this.fc.registerOnDisabledChange((shouldDisable) => {
      this.multiSelect.settings.disabled = shouldDisable;
    });
  }

  ngOnChanges({ options }: SimpleChanges): void {
    if (options?.currentValue.length > 0) {
      this.parseSelectedOptions(this.fc.value);
    }
  }

  parseSelectedOptions(selectedOptions: any | undefined): void {
    if (this.options.length > 0 && selectedOptions) {
      this.innerControl.setValue(
        selectedOptions
          .map((obj: any) => {
            return this.options.find(
              (option) =>
                this.findIdProperty(option) === this.findIdProperty(obj)
            );
          })
          .filter((val: any) => !!val) ?? []
      );
    }
  }

  findIdProperty(item: Record<string, any> | number): string | number | null {
    if (typeof item === 'number') {
      return item;
    }

    const key = Object.keys(item).find(
      (key) => key === 'id' || key.includes('_id')
    );
    return key ? item[key] : null;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
